import { useMemo, useState } from 'react'

import type { SearchResult } from '../types'
import GalleryFiltersV3 from './GalleryFiltersV3'

type GalleryFilterV3Props = {
  searchResult: SearchResult | undefined
  totalCount: number
}

const GalleryFilterV3 = ({
  searchResult,
  totalCount,
}: GalleryFilterV3Props) => {
  const facetsv2 = useMemo(() => {
    return searchResult?.facets
  }, [searchResult])

  const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false)

  return (
    <>
      <GalleryFiltersV3
        facetsv2={facetsv2}
        isFilterOpen={isFilterOpen}
        setIsFilterOpen={setIsFilterOpen}
        totalCount={totalCount}
      />
    </>
  )
}

export default GalleryFilterV3
